<template>
  <router-link :to="backLink.previousPage.fullPath" class="back-link">
    <span class="back-link__icon iconfont iback"></span>
    <span class="back-link__text">{{ backLink.previousPageLabel }}</span>
  </router-link>
</template>

<script setup lang="ts">
import { backLink } from '@/models/backlink'
</script>

<style lang="scss" scoped>
.back-link {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  color: $c-black-3;

  @include hover {
    color: $c-black-2;
  }

  &__text {
    font-size: 14px;
    line-height: 1;
    color: inherit;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  &__icon {
    min-width: 0;
    font-size: 16px;
    color: inherit;
  }
}

.night-mode .back-link {
  color: $c-black-4;

  @include hover {
    color: $c-white;
  }
}
</style>
